export default class RouterProvider {
  /* @ngInject */
  constructor($stateProvider, $urlRouterProvider, $locationProvider) {
    this.$stateProvider = $stateProvider;
    this.$urlRouterProvider = $urlRouterProvider;
    this.$locationProvider = $locationProvider;
    this.$get = ['$state', '$transitions', '$location', RouterProvider.routerService];
  }

  configureStates(states) {
    states.forEach(({state, config}) => {
      this.$stateProvider.state(state, config);
    });
  }

  configureOtherwisePath(otherwisePath) {
    this.$urlRouterProvider.otherwise(otherwisePath);
  }

  html5Mode(value) {
    this.$locationProvider.html5Mode(value);
  }

  static routerService($state, $transitions, $location) {
    return {
      getStates() {
        return $state.get();
      },
      onBefore(match, callback, options) {
        $transitions.onBefore(match, callback, options);
      },
      onStart(match, callback, options) {
        $transitions.onStart(match, callback, options);
      },
      onEnter(match, callback, options) {
        $transitions.onEnter(match, callback, options);
      },
      onSuccess(match, callback, options) {
        $transitions.onSuccess(match, callback, options);
      },
      state: $state,
      location: $location,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/router/router.provider.js